export default {"src":"/_next/static/media/pebbleWhite.4c2b69a7.svg","height":498,"width":1245,"blurWidth":0,"blurHeight":0};